import { useMemo } from "react";
import {
    FieldType,
    HPHGroupTitle,
    IFieldValue
} from "veronica-ui-component/dist/component/core";
// import _ from "lodash";
import { getDefaultBuConfig, getDefaultBuConfigElement } from "domain/repository/apiUtil";
import { CriteriaDirectoryContainerCheckboxOption } from "presentation/constant/ChargeDataEnquiry/CriteriaDirectoryCheckboxOption";
import { ChargeConstant } from "presentation/constant/ChargeHeader/ChargeConstant";
import { endVisitIndDropdownOption, fullEmptyDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { useChargeDataSearchVM } from "presentation/hook/ChargeDataEnquiry/useChargeDataSearchVM";
import { useChargeDataSearchTracked } from "presentation/store/ChargeDataEnquiry/ChargeDataSearchProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NbisInputDropDown from "presentation/view/components/NbisInputDropDown";


export const ChargeDataSearchCriteriaEditContainerPanel = () => {


    const CHARGE_CONSTANT = ChargeConstant.Charge;
    const [chargeDataSearchState] = useChargeDataSearchTracked();
    const isRailEnabled: boolean = getDefaultBuConfigElement<boolean>("REACT_APP_FIELD_ENABLE", "RAIL") || false;
    const isRailMaster: boolean = getDefaultBuConfig<boolean>('REACT_APP_RAIL_ENABLE') || false;
    const blNoMaxLength: number = getDefaultBuConfig<number>("REACT_APP_BILL_OF_LADING_MAX_LENGTH") || 35;
    const chargeDataSearchCriteria = chargeDataSearchState.searchCriteria
    const chargeDataSearchVM = useChargeDataSearchVM();
    const enabledCriteria = useMemo(() => CriteriaDirectoryContainerCheckboxOption?.find(item => chargeDataSearchState.enabledSearchCriteria[item.key]), [chargeDataSearchState.enabledSearchCriteria])

    const memoCntrNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                helpTextElement={"Use line break ( Enter ) as delimiter"}
                readOnlyValue={chargeDataSearchCriteria.cntrList?.join('\n') || ''}
                fieldValue={chargeDataSearchCriteria?.cntrList?.join('\n')}
                fieldLabel={CHARGE_CONSTANT.CNTR_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXTAREA}
                fieldKey={'cntrList'}
                maxLength={780}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onTextAreaChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDataSearchCriteria.cntrList, chargeDataSearchVM, CHARGE_CONSTANT.CNTR_NO])


    const memoShippingBill = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDataSearchCriteria.soNumber1 || ''}
                fieldValue={chargeDataSearchCriteria.soNumber1}
                fieldLabel={CHARGE_CONSTANT.SHIPPING_BILL}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'soNumber1'}
                maxLength={35}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_CONSTANT.SHIPPING_BILL, chargeDataSearchCriteria.soNumber1, chargeDataSearchVM])

    const memoBillOfLading = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDataSearchCriteria.blNo1 || ''}
                fieldValue={chargeDataSearchCriteria.blNo1}
                fieldLabel={CHARGE_CONSTANT.BILL_OF_LADING}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'blNo1'}
                maxLength={blNoMaxLength}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_CONSTANT.BILL_OF_LADING, blNoMaxLength, chargeDataSearchCriteria.blNo1, chargeDataSearchVM])

    const memoServiceRequestRef = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDataSearchCriteria.serviceRequestRf || ''}
                fieldValue={chargeDataSearchCriteria.serviceRequestRf}
                fieldLabel={CHARGE_CONSTANT.SERVICE_REQUEST_REF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'serviceRequestRf'}
                maxLength={35}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_CONSTANT.SERVICE_REQUEST_REF, chargeDataSearchCriteria.serviceRequestRf, chargeDataSearchVM])

    const memoTrainId = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDataSearchCriteria.trainId || ''}
                fieldValue={chargeDataSearchCriteria.trainId}
                fieldLabel={CHARGE_CONSTANT.TRAIN_ID}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'trainId'}
                maxLength={12}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_CONSTANT.TRAIN_ID, chargeDataSearchCriteria.trainId, chargeDataSearchVM])

    const memoSize = useMemo(() =>
        <div className='im-flex-row-item'>
            <NbisInputDropDown
                label={CHARGE_CONSTANT.SIZE}
                width='150px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={chargeDataSearchCriteria.sizeList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => chargeDataSearchVM.onMultipleDropdownChange(e, 'sizeList')}
                options={chargeDataSearchState.dynamicOptions.sizeGroupDropdownOptions} />
        </div>
        , [chargeDataSearchCriteria.sizeList, chargeDataSearchVM, chargeDataSearchState.dynamicOptions.sizeGroupDropdownOptions, CHARGE_CONSTANT.SIZE])
    const memoType = useMemo(() =>
        <div className='im-flex-row-item'>
            <NbisInputDropDown
                label={CHARGE_CONSTANT.TYPE}
                width='150px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={chargeDataSearchCriteria.typeList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => chargeDataSearchVM.onMultipleDropdownChange(e, 'typeList')}
                options={chargeDataSearchState.dynamicOptions.typeDropdownOptions} />
        </div>
        , [chargeDataSearchCriteria.typeList, chargeDataSearchVM, chargeDataSearchState.dynamicOptions.typeDropdownOptions, CHARGE_CONSTANT.TYPE])
    // const memoModalityOfArrival = useMemo(() =>
    //     <div className='im-flex-row-item'>
    //         <NbisInputDropDown
    //             label={CHARGE_CONSTANT.MODALITY_OF_ARRIVAL}
    //             width='150px'
    //             inputType="freeText"
    //             mode={'multiple'}
    //             sort={false}
    //             value={chargeDataSearchCriteria.modalityOfArrivalList?.map((item) => ({
    //                 value: item
    //             }))}
    //             onChange={(e: any) => chargeDataSearchVM.onMultipleDropdownChange(e, 'modalityOfArrivalList')}
    //             options={modalityDropdownOption} />
    //     </div>
    //     , [chargeDataSearchCriteria.modalityOfArrivalList, chargeDataSearchVM, CHARGE_CONSTANT.MODALITY_OF_ARRIVAL])
    // const memoModalityOfDepature = useMemo(() =>
    //     <div className='im-flex-row-item'>
    //         <NbisInputDropDown
    //             label={CHARGE_CONSTANT.MODALITY_OF_DEPATURE}
    //             width='150px'
    //             inputType="freeText"
    //             mode={'multiple'}
    //             sort={false}
    //             value={chargeDataSearchCriteria.modalityofDepatureList?.map((item) => ({
    //                 value: item
    //             }))}
    //             onChange={(e: any) => chargeDataSearchVM.onMultipleDropdownChange(e, 'modalityofDepatureList')}
    //             options={modalityDropdownOption} />
    //     </div>
    //     , [chargeDataSearchCriteria.modalityofDepatureList, chargeDataSearchVM, CHARGE_CONSTANT.MODALITY_OF_DEPATURE])
    const memoFullEmpty = useMemo(() =>
        <div className='im-flex-row-item'>
            <NbisInputDropDown
                label={CHARGE_CONSTANT.FULL_EMPTY}
                width='150px'
                inputType="freeText"
                mode={'single'}
                sort={false}
                value={chargeDataSearchCriteria.fullEmptyInd}
                onChange={(e: any) => chargeDataSearchVM.onDropdownChange(e, 'fullEmptyInd')}
                options={fullEmptyDropdownOption} />
        </div>
        , [chargeDataSearchCriteria.fullEmptyInd, chargeDataSearchVM, CHARGE_CONSTANT.FULL_EMPTY])
    const memoGateInFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={CHARGE_CONSTANT.GATE_IN_RANGE}
                width="330px"
                fieldNames={{ startField: "gateInFrom", endField: "gateInTo" }}
                dateRange={{ startDate: chargeDataSearchCriteria.gateInFrom, endDate: chargeDataSearchCriteria.gateInTo }}
                onDatesChange={chargeDataSearchVM.onDateRangeChange}
            />
        </div>
        , [chargeDataSearchCriteria.gateInFrom, chargeDataSearchCriteria.gateInTo, chargeDataSearchVM, CHARGE_CONSTANT.GATE_IN_RANGE])
    const memoGateOutFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={CHARGE_CONSTANT.GATE_OUT_RANGE}
                width="330px"
                fieldNames={{ startField: "gateOutFrom", endField: "gateOutTo" }}
                dateRange={{ startDate: chargeDataSearchCriteria.gateOutFrom, endDate: chargeDataSearchCriteria.gateOutTo }}
                onDatesChange={chargeDataSearchVM.onDateRangeChange}
            />
        </div>
        , [chargeDataSearchCriteria.gateOutFrom, chargeDataSearchCriteria.gateOutTo, chargeDataSearchVM, CHARGE_CONSTANT.GATE_OUT_RANGE])
    const memoSpecialHandlingCode = useMemo(() =>
        <div className='im-flex-row-item'>
            <NbisInputDropDown
                label={CHARGE_CONSTANT.SPECIAL_HANDLING_CODE}
                width='330px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={chargeDataSearchCriteria.specHandlingCodeList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => chargeDataSearchVM.onMultipleDropdownChange(e, 'specHandlingCodeList')}
                options={chargeDataSearchState.dynamicOptions.specHandingCodeDropdownOptions} />
        </div>
        , [chargeDataSearchCriteria.specHandlingCodeList, chargeDataSearchVM, chargeDataSearchState.dynamicOptions.specHandingCodeDropdownOptions, CHARGE_CONSTANT.SPECIAL_HANDLING_CODE])
    // const memoSpecialHandlingCodeD1 = useMemo(() =>
    //     <div className='im-flex-row-item'>
    //         <NbisInputDropDown
    //             label={CHARGE_CONSTANT.SPECIAL_HANDLING_CODE_D1}
    //             width='150px'
    //             inputType="freeText"
    //             mode={'multiple'}
    //             sort={false}
    //             value={chargeDataSearchCriteria.specHandlingCodeD1List?.map((item) => ({
    //                 value: item
    //             }))}
    //             onChange={(e: any) => chargeDataSearchVM.onMultipleDropdownChange(e, 'specHandlingCodeD1List')}
    //             options={chargeDataSearchState.dynamicOptions.specHandingCodeD1DropdownOptions} />
    //     </div>
    //     , [chargeDataSearchCriteria.specHandlingCodeD1List, chargeDataSearchVM, chargeDataSearchState.dynamicOptions.specHandingCodeD1DropdownOptions, CHARGE_CONSTANT.SPECIAL_HANDLING_CODE_D1])
    const memoEndVisitInd = useMemo(() =>
        <div className='im-flex-row-item'>
            <NbisInputDropDown
                label={CHARGE_CONSTANT.END_VISIT_IND}
                width='150px'
                inputType="freeText"
                mode={'single'}
                sort={false}
                value={chargeDataSearchCriteria.endVisitInd}
                onChange={(e: any) => chargeDataSearchVM.onDropdownChange(e, 'endVisitInd')}
                options={endVisitIndDropdownOption} />
        </div>
        , [chargeDataSearchCriteria.endVisitInd, chargeDataSearchVM, CHARGE_CONSTANT.END_VISIT_IND])
    // const memoFromTml = useMemo(() =>
    //     <div className='im-flex-row-item'>
    //         <NbisInputDropDown
    //             label={CHARGE_CONSTANT.FROM_TML}
    //             width='150px'
    //             inputType="freeText"
    //             mode={'multiple'}
    //             sort={false}
    //             value={chargeDataSearchCriteria.fromTml?.map((item) => ({
    //                 value: item
    //             }))}
    //             onChange={(e: any) => chargeDataSearchVM.onMultipleDropdownChange(e, 'fromTml')}
    //             options={chargeDataSearchState.dynamicOptions.fromTmlDropdownOptions} />
    //     </div>
    //     , [chargeDataSearchCriteria.fromTml, chargeDataSearchVM, chargeDataSearchState.dynamicOptions.fromTmlDropdownOptions, CHARGE_CONSTANT.FROM_TML])
    // const memoToTml = useMemo(() =>
    //     <div className='im-flex-row-item'>
    //         <NbisInputDropDown
    //             label={CHARGE_CONSTANT.TO_TML}
    //             width='150px'
    //             inputType="freeText"
    //             mode={'multiple'}
    //             sort={false}
    //             value={chargeDataSearchCriteria.toTml?.map((item) => ({
    //                 value: item
    //             }))}
    //             onChange={(e: any) => chargeDataSearchVM.onMultipleDropdownChange(e, 'toTml')}
    //             options={chargeDataSearchState.dynamicOptions.toTmlDropdownOptions} />
    //     </div>
    //     , [chargeDataSearchCriteria.toTml, chargeDataSearchVM, chargeDataSearchState.dynamicOptions.toTmlDropdownOptions, CHARGE_CONSTANT.TO_TML])


    const memoPanel = useMemo(() => <div className='im-charge-data-search-criteria-group'>
        <HPHGroupTitle titleText={CHARGE_CONSTANT.CONTAINER} />
        <CriteriaItemContainer>
            {chargeDataSearchState.enabledSearchCriteria.cntrList ? <>{memoCntrNo}</> : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {chargeDataSearchState.enabledSearchCriteria.blNo1 ? <>{memoBillOfLading}</> : null}
            {chargeDataSearchState.enabledSearchCriteria.soNumber1 ? <>{memoShippingBill}</> : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {chargeDataSearchState.enabledSearchCriteria.serviceRequestRf ? <>{memoServiceRequestRef}</> : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {isRailEnabled && isRailMaster && chargeDataSearchState.enabledSearchCriteria.trainId ? <>{memoTrainId}</> : null}
        </CriteriaItemContainer>
        {/* <CriteriaItemContainer>
            {chargeDataSearchState.enabledSearchCriteria.handlingTmlList ? memoHandlingTml : null}
            {chargeDataSearchState.enabledSearchCriteria.operationTypeList ? memoOperationType : null}
        </CriteriaItemContainer> */}
        {/* <CriteriaItemContainer>
            {chargeDataSearchState.enabledSearchCriteria.bundleIndList ? memoBundleInd : null}
            {chargeDataSearchState.enabledSearchCriteria.cntrVisit ? memoCntrVisit : null}
        </CriteriaItemContainer> */}
        <CriteriaItemContainer>
            {chargeDataSearchState.enabledSearchCriteria.sizeList ? memoSize : null}
            {chargeDataSearchState.enabledSearchCriteria.typeList ? memoType : null}
        </CriteriaItemContainer>
        {/* <CriteriaItemContainer>
            {chargeDataSearchState.enabledSearchCriteria.modalityOfArrivalList ? memoModalityOfArrival : null}
            {chargeDataSearchState.enabledSearchCriteria.modalityofDepatureList ? memoModalityOfDepature : null}
        </CriteriaItemContainer> */}
        <CriteriaItemContainer>
            {chargeDataSearchState.enabledSearchCriteria.fullEmptyInd ? memoFullEmpty : null}
            {chargeDataSearchState.enabledSearchCriteria.endVisitInd ? memoEndVisitInd : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {chargeDataSearchState.enabledSearchCriteria.gateIn ? memoGateInFromTo : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {chargeDataSearchState.enabledSearchCriteria.gateOut ? memoGateOutFromTo : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {chargeDataSearchState.enabledSearchCriteria.specHandlingCodeList ? memoSpecialHandlingCode : null}
            {/* {chargeDataSearchState.enabledSearchCriteria.specHandlingCodeD1List ? memoSpecialHandlingCodeD1 : null} */}
        </CriteriaItemContainer>
        {/* <CriteriaItemContainer>
            {chargeDataSearchState.enabledSearchCriteria.fromTml ? memoFromTml : null}
            {chargeDataSearchState.enabledSearchCriteria.toTml ? memoToTml : null}
        </CriteriaItemContainer> */}
    </div>, [CHARGE_CONSTANT.CONTAINER, chargeDataSearchState.enabledSearchCriteria.blNo1, chargeDataSearchState.enabledSearchCriteria.cntrList, chargeDataSearchState.enabledSearchCriteria.endVisitInd, chargeDataSearchState.enabledSearchCriteria.fullEmptyInd, chargeDataSearchState.enabledSearchCriteria.gateIn, chargeDataSearchState.enabledSearchCriteria.gateOut, chargeDataSearchState.enabledSearchCriteria.sizeList, chargeDataSearchState.enabledSearchCriteria.soNumber1, chargeDataSearchState.enabledSearchCriteria.specHandlingCodeList, chargeDataSearchState.enabledSearchCriteria.typeList, chargeDataSearchState.enabledSearchCriteria.trainId, memoBillOfLading, memoCntrNo, memoEndVisitInd, memoFullEmpty, memoGateInFromTo, memoGateOutFromTo, memoShippingBill, memoSize, memoSpecialHandlingCode, memoType, memoTrainId, isRailEnabled, isRailMaster, memoServiceRequestRef, chargeDataSearchState.enabledSearchCriteria.serviceRequestRf]);

    if (!enabledCriteria) return null;
    return memoPanel;
};
